import DownloadPdfUsingTemplateModal from '@shared/components/modals/download-pdf-using-template-modal/download-pdf-using-template-modal.vue';
import { DownloadPdfUsingTemplateModel, Template } from '@tools/interfaces/template';
import Vue from 'vue';
import { Component } from 'vue-property-decorator';

@Component({
  components: {
    'bpc-download-pdf-using-template-modal': DownloadPdfUsingTemplateModal,
  },
})
export default class DownloadPdfUsingTemplateMixin extends Vue {
  // DATA
  isDownloadingPdfUsingTemplate = false;
  declare entityName;
  showDownloadPdfUsingTemplateModal: boolean = false;
  downloadPdfUsingTemplateErrors: Record<string, string[]> = null;
  downloadPdfUsingTemplateSelectedItemIds: number[] = [];
  downloadPdfUsingTemplateAvailabilityContext: string = 'none';
  availableTemplatesForDownloadPdf: Template[] = [];

  // LIFECYCLE
  mounted() {
    this.downloadPdfUsingTemplateAvailabilityContext = this.$clientRouter.getContext();
  }

  // METHODS

  async getAllowedTemplatesForDownloadPdf() {
    const params = {
      entity: this.entityName,
      available_in: this.downloadPdfUsingTemplateAvailabilityContext,
      type: 'pdf',
    };
    const templateRoute = this.$bpcApiRouteHelper.getEntityPath('template');
    const res = await this.$bpcApi.get(templateRoute, { params }).toPromise();
    this.availableTemplatesForDownloadPdf = res.data;
  }

  async onBulkDownloadPdfUsingTemplate(selection: number[]) {
    this.downloadPdfUsingTemplateSelectedItemIds = selection;
    this.downloadPdfUsingTemplateCleanErrors();
    this.openDownloadPdfUsingTemplateModal();
  }

  async onDownloadPdfUsingTemplate(item) {
    this.downloadPdfUsingTemplateSelectedItemIds = item?.id ? [item?.id] : [];
    this.downloadPdfUsingTemplateCleanErrors();
    this.openDownloadPdfUsingTemplateModal();
  }

  openDownloadPdfUsingTemplateModal() {
    this.showDownloadPdfUsingTemplateModal = true;
  }
  async closeDownloadPdfUsingTemplateModal() {
    this.isDownloadingPdfUsingTemplate = false;
    this.showDownloadPdfUsingTemplateModal = false;
    this.downloadPdfUsingTemplateCleanErrors();
  }

  async onConfirmDownloadPdfUsingTemplate(formModel: DownloadPdfUsingTemplateModel) {
    this.isDownloadingPdfUsingTemplate = true;
    try {
      const res = await this.downloadPdfUsingTemplate(formModel);
      this.closeDownloadPdfUsingTemplateModal();
    } catch (error) {
      const errors = error?.response?.data?.errors;
      this.downloadPdfUsingTemplateErrors = errors;
      this.isDownloadingPdfUsingTemplate = false;
    }
  }

  downloadPdfUsingTemplateCleanErrors() {
    this.downloadPdfUsingTemplateErrors = {};
  }

  async downloadPdfUsingTemplate(formModel: DownloadPdfUsingTemplateModel) {
    const path = `${this.$bpcApiRouteHelper.getEntityPath('templates')}/download-pdf`;
    return await this.$bpcApi.postDownload(path, '', formModel).toPromise();
  }
}
